// Production API endpoint (direct)
const apiEndpointDirect = 'https://wp.gimnazijasvetisava.edu.rs/graphql';

// Development API endpoint (with caching proxy)
const apiEndpointCached = 'http://localhost:4000/graphql';

// Production API endpoint (through Nginx to Redis cache)
const apiEndpointProduction = '/api/graphql';

// Use cached endpoint in development, cached through Nginx in production
const isDevelopment = process.env.NODE_ENV === 'development';
const apiEndpoint = apiEndpointDirect;

// Alternative WordPress GraphQL endpoint (fallback)
// const apiEndpoint = 'https://wp.gimnazijasvetisava.edu.rs/index.php?graphql';

export default apiEndpoint;